import { Component, Host, h } from '@stencil/core'

/**
 * Represents the contact information.
 */
@Component({
    tag: 'wf-contact-display',
    styleUrl: 'wf-contact-display.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfContactDisplay {
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (
            <Host>
                <div class="title" part="title">Kontakt &amp; Beratung</div>
                <div class="rows" part="rows">
                    <div class="box" part="box">
                        <vx-icon icon="phone"/>
                        <div class="box-content">
                            <div>0221 - 97 58 42 40</div>
                            <div>von Mo-Fr, 9-18 Uhr (außer an Feiertagen)</div>
                        </div>
                    </div>
                    <div class="box" part="box">
                        <vx-icon icon="mail"/>
                        <div class="box-content">
                            <a href="mailto:info@weinfreunde.de">info@weinfreunde.de</a>
                        </div>
                    </div>
                </div>
            </Host>
        )
    }

}
